<mat-tab-group mat-stretch-tabs>
  <mat-tab label="Import">
    <app-giact-import></app-giact-import>
  </mat-tab>
  <mat-tab label="Export">
    <app-giact-export></app-giact-export>
  </mat-tab>
</mat-tab-group>
